module.exports = __webpack_public_path__ + "assets/img/sorry.8b75f6e6.png";